// src/pages/Health/api.js
// Слой доступа к данным раздела «Здравоохранение» (АРМ, UC.05.02).
// Переведён на реальный бэкенд health-controller. Моки удалены.
//
//   GET  /api/health/indicators → { indicators: [...] }  (справочник, задача Арману)
//   GET  /api/health/records    → { rows: [...] }        (перечень, задача Арману)
//   POST /api/health/records    → 201 + созданная запись
//
// meta/snapshot/series/dashboard — это API дашборда (UC.05.01), в АРМ не нужны.

import { getNetwork } from '../../utils/getNetwork';
import { API_ROOT } from '../../config';

const INDICATORS_ENDPOINT = '/api/health/indicators';
const RECORDS_ENDPOINT = '/api/health/records';

export class ApiError extends Error {
  constructor(status, body) {
    super('api_error');
    this.status = status;
    this.body = body;
  }
}

// Бэк отдаёт названия/единицы в ключах *_kz; внутри фронта исторически *_kk.
function toIndicator(i, idx) {
  return {
    code: i.code,
    name_ru: i.name_ru,
    name_kk: i.name_kz != null ? i.name_kz : i.name_kk,
    unit_ru: i.unit_ru,
    unit_kk: i.unit_kz != null ? i.unit_kz : i.unit_kk,
    direction: i.direction, // 'lower_better' | 'higher_better'
    sort_order: i.sort_order != null ? i.sort_order : idx + 1,
  };
}

/* ------------------------------ Справочник ------------------------------ */
export async function fetchHealthMeta() {
  const res = await getNetwork().get(API_ROOT + INDICATORS_ENDPOINT);
  const data = res.data || {};
  const list = Array.isArray(data.indicators) ? data.indicators : [];
  return { indicators: list.map(toIndicator) };
}

/* ------------------------------- Перечень ------------------------------- */
export async function fetchHealthRows() {
  const res = await getNetwork().get(API_ROOT + RECORDS_ENDPOINT);
  const data = res.data || {};
  const rows = Array.isArray(data.rows) ? data.rows : Array.isArray(data) ? data : [];
  return { rows };
}

/* ------------------------------- Создание ------------------------------- */
// payload: { indicator_code, period_type, year, quarter|null, plan, fact, note|null }
export async function createHealthRow(payload) {
  try {
    const res = await getNetwork().post(API_ROOT + RECORDS_ENDPOINT, payload);
    if (res && res.status === 201) return normalizeCreated(res.data);
    if (res) throw new ApiError(res.status, res.data);
    throw new ApiError(0, null);
  } catch (e) {
    if (e instanceof ApiError) throw e;
    throw new ApiError((e.response && e.response.status) || 0, e.response && e.response.data);
  }
}

// Ответ 201 несёт доп. поля (indicator_name, created_at, created_by) — берём нужное.
function normalizeCreated(d) {
  d = d || {};
  return {
    id: d.id,
    indicator_code: d.indicator_code,
    period_type: d.period_type,
    year: d.year,
    quarter: d.quarter != null ? d.quarter : null,
    plan: d.plan,
    fact: d.fact,
    note: d.note != null ? d.note : null,
  };
}
